import * as React from 'react';

import { vfx_images } from './vfx_images';
import { Gallery } from '../core/Gallery';

export const VFXSection = () => {
  return <Gallery images={vfx_images} />;
};
